import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import App from './App'
import router from './router'
import store from './store'
import Qc from './components/Qc'
import wxSdk from './util/wxSdk'
import mixins from './mixins'
import http from './api'
import * as filters from './filter'
const FastClick = require('fastclick')
const vConsole = require('vconsole')

FastClick.attach(document.body)
Vue.config.productionTip = false
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.component(Qc.name, Qc)

Vue.mixin(mixins)

if (location.href.indexOf('debug=true') != -1) {
new vConsole()
}

Vue.prototype.$http = http
Vue.prototype.$wxSdk = wxSdk
if (process.env.NODE_ENV === 'production') {
Vue.prototype.$ROOTURL = location.origin + location.pathname.match(/^\/\w+/g)[0]
}
Vue.prototype.imgHost = 'http://athena-1255600302.cosgz.myqcloud.com'
Vue.prototype.imgCut = 'http://athena-1255600302.picgz.myqcloud.com'
Vue.prototype.cutParam1 = '?imageView2/1/w/200/h/164'
Vue.prototype.cutParam2 = '?imageView2/1/w/750/h/360'
Vue.prototype.cutParam3 = '?imageView2/1/w/750/h/290'
Vue.prototype.cutParam4 = '?imageView2/1/w/97/h/97'
Vue.prototype.toast = function(text) {
this.$vux.toast.show({
text: text,
type: 'text',
time: 1500
})
}


router.beforeEach((to, from, next) => {
if (to.meta.title) {
document.title = to.meta.title
} else {
document.title = store.state.wxConfig.wxName || '首页'
}
window.document.body.style.backgroundColor = to.meta.backgroundColor || ''
next()
})


router.onError((error) => {
const pattern = /Loading chunk (\d)+ failed/g
const isChunkLoadFailed = error.message.match(pattern)
if (isChunkLoadFailed) {

window.location.reload()


} else {

console.log('router错误信息：', error)
}
})

wxSdk.loadJsapiTicketSign()

Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})

new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js